import { cn } from '@aw/lib'
import { cva, VariantProps } from 'class-variance-authority'
import React from 'react'

type Props = {
    children: React.ReactNode
    size?: VariantProps<typeof LabelVariants>['size']
    required?: boolean
    testId?: string
} & Omit<React.HTMLProps<HTMLLabelElement>, 'size'>


export const LabelVariants = cva("", {
    variants: {
        size: {
            "xs": "text-sm",
            "sm": "text-base",
            "md": "text-base"
        }
    },
    defaultVariants: {
        size: "sm"
    }
})


function Label({ children, required, size, testId, ...props }: Props) {

    return (
        <label data-testid={testId} className={cn('text-foreground font-medium', LabelVariants({ size }))} {...props}>
            {children}
            {required && <span className='text-red-base ml-1'>*</span>}
        </label>
    )
}

export default Label